var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayFold)?_c('div',{staticClass:"foldBtn-wrap",on:{"click":_vm.foldSwitch}},[_vm._v("\n  "+_vm._s(_vm.$t('common.unfold'))+"\n  "),_c('van-icon',{staticClass:"fold",staticStyle:{"transform":"rotate(90deg)"},attrs:{"name":'play-circle-o'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }